module.exports = __webpack_public_path__ + "img/bg.fc4a8fad.png";